export const AlarmLevels = { INFO: "INFO", WARNING: "WARNING", CRITICAL: "CRITICAL" } as const
export type AlarmLevel = (typeof AlarmLevels)[keyof typeof AlarmLevels]

export const LEVEL_VARIANTS: Record<AlarmLevel, string> = {
    CRITICAL: "danger",
    WARNING: "warning",
    INFO: "info",
}

export const LEVEL_ICONS: Record<AlarmLevel, string> = {
    CRITICAL: "fa-solid fa-circle-xmark",
    WARNING: "fa-solid fa-triangle-exclamation",
    INFO: "fa-solid fa-circle-info",
}

const AlarmSources = { CONTROLLER: "controller", CLOUD: "cloud", PREDICTOR: "predictor" } as const
export type AlarmSource = (typeof AlarmSources)[keyof typeof AlarmSources]

export type Alarm = {
    id: number
    type: string
    level: AlarmLevel
    status: string
    source: AlarmSource
    deviceId: number | null
    deviceName: string | null
    controllerId: number | null
    controllerUnitId: string | null
    locationId: number | null
    locationName: string | null
    conditionStartedAt: string | null
    cloudDetectedAt: string | null
    raisedAt: string | null
    resolvedAt: string | null
}

export type AlarmCounts = {
    total: number
    byLevel: Record<AlarmLevel, number>
}

export const AlarmAnchorTypes = {
    LOCATION: "location",
    CONTROLLER: "controller",
    DEVICE: "device",
    LOCATION_GROUP: "locationGroup",
} as const

export type AlarmAnchorType = (typeof AlarmAnchorTypes)[keyof typeof AlarmAnchorTypes]

export const anchorTypeEndpoints: Record<AlarmAnchorType, string> = {
    location: "locations",
    controller: "controllers",
    device: "devices",
    locationGroup: "locations-group",
} as const

type AlarmAnchor = {
    type: AlarmAnchorType
    id: number
    name: string
}

export type AlarmData = {
    data: {
        alarms: Alarm[]
        counts: AlarmCounts
        anchor: AlarmAnchor
    }
}
